import { useEffect, useRef } from 'react';
// import mqtt from 'mqtt';
import mqtt from 'mqtt/dist/mqtt.min';
import { MQTT_USER, MQTT_PASS } from '~/services/authentication';

const MQTT_BROKER = `${process.env.REACT_APP_MOSQUITTO_HOST}/mqtt`;

export default function useRealtimeSignal({ topic, onSignal }) {
  const onSignalRef = useRef(onSignal);
  onSignalRef.current = onSignal;

  useEffect(() => {
    const options = {
      username: localStorage.getItem(MQTT_USER),
      password: localStorage.getItem(MQTT_PASS),
      // reconnectPeriod: 1000,
      // keepalive: 30,
      // clean: true,
    };

    const client = mqtt.connect(MQTT_BROKER, options);

    client.on('connect', () => {
      client.subscribe(topic, (err) => {
        if (err) {
          console.error('Subscription error:', err);
        } else {
          console.log(`Subscribed to topic: ${topic}`);
        }
      });
    });

    client.on('message', () => {
      if (onSignalRef.current) {
        onSignalRef.current();
      }
    });

    client.on('error', e => console.error('[MQTT]', e));
    client.on('close', () => console.log('[MQTT] closed'));
    client.on('offline', () => console.log('[MQTT] offline'));

    return () => client.end(true);
  }, [topic]);
}
